export const DAEMON = 'DAEMON'
export const ONCE_TILL_UNMOUNT = 'ONCE_TILL_UNMOUNT'
export const RESTART_ON_REMOUNT = 'RESTART_ON_REMOUNT'
